
seedWebApp.controller('ApprovalModalController', ['$scope', '$uibModalInstance', 'TranslationService', 'HelpdeskService', 'info',
    function ApprovalModalController($scope, $uibModalInstance, TranslationService, HelpdeskService, info) {

        $scope.translation = TranslationService.getActiveTranslation();
        //console.log('approvalModal');
        $scope.info = info;
        console.log('approvalModal', info);

        $scope.ok = function (isApproved) {
            var res = {
                IsApproved: isApproved,
                Comment: $scope.approvalComment,
                UserID: info.User.UserID
            }
            $uibModalInstance.close(res);
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

    }]
);